import React from "react";
import SimplePageBanner from "../SimplePageBanner";
import { pageTitle } from "../../helpers/PageTitle";
import "../../sass/shortcode/PrivacyPolicy.scss";

export default function PrivacyPolicy() {
  pageTitle("Privacy Policy");

  return (
    <>
      {/* Header Banner */}
      <SimplePageBanner
        mainIcon="ph:shield-light"
        innerIcon="mdi:lock"
        badgeIcon="mdi:account"
        title="Privacy Policy"
        subtitle="How We Protect & Manage Your Data"
      />

      {/* Privacy Policy Content */}
      <div className="policy-container">
        <h2 className="policy-heading">Overview</h2>
        <p>
          ➤ This policy (<strong>Medayus Data Privacy Policy</strong>) explains
          what personal data is collected, how such data is processed and secured,
          how it is used, and the conditions of disclosure, if any.
        </p>

        <h2 className="policy-heading">Purpose</h2>
        <p>
          ➤ To explain the types of personal data collected, when and why we collect
          it, how we use it, conditions of disclosure to third parties, security
          measures, and your rights with respect to your data.
        </p>

        <h2 className="policy-heading">Scope</h2>
        <p>
          ➤ This Policy applies to all personal data collected, used, stored, or
          processed by <strong>Medayus Hospital Limited</strong> or its
          subsidiaries, including data collected via websites, hospital services,
          and digital platforms.
        </p>

        <h2 className="policy-heading">Policy</h2>
        <p>➤ Personal Information may include:</p>
        <ul className="policy-list">
          <li>▪ Name, Gender, Date of Birth/Age</li>
          <li>▪ Contact details (Mobile/Email)</li>
          <li>▪ Permanent Address</li>
          <li>▪ Sexual Orientation</li>
          <li>▪ Medical records and history</li>
          <li>▪ Health status including physical/mental conditions</li>
          <li>▪ Government ID proof (Aadhar, PAN, Driving License)</li>
          <li>▪ Insurance details</li>
        </ul>
        <p>
          ➤ Such information will be collected, stored, and processed in compliance
          with applicable laws.
        </p>

        <h2 className="policy-heading">Data Security</h2>
        <p>
          ➤ We implement strict technical and organizational measures to safeguard
          your personal data against unauthorized access, loss, misuse, alteration,
          or disclosure.
        </p>

        <h2 className="policy-heading">Your Rights</h2>
        <p>
          ➤ You have the right to access, update, or request deletion of your
          personal data. You may also withdraw consent for processing, subject to
          applicable laws and regulations.
        </p>

                <h2 className="policy-heading">Appointment Cancellation</h2>
        <ul className="policy-list">
          <li>➤ Appointments can be cancelled or rescheduled up to 24 hours in advance without any charges.</li>
          <li>➤ Cancellations made within 24 hours may attract a cancellation fee of up to 50% of the consultation fee.</li>
          <li>➤ No-shows (missed appointments without prior notice) are non-refundable.</li>
        </ul>

        <h2 className="policy-heading">Refund Policy</h2>
        <ul className="policy-list">
          <li>➤ Consultation fees once paid are generally non-refundable after the consultation has been completed.</li>
          <li>➤ Refunds will be considered only for: Duplicate payment, Technical issues preventing the consultation, Cancellation within the allowed time window.</li>
          <li>➤ Approved refunds will be processed within 5–10 business days to the original mode of payment.</li>
        </ul>

        <h2 className="policy-heading">Rescheduling Policy</h2>
        <ul className="policy-list">
          <li>➤ Patients may reschedule appointments once without additional charges if requested at least 24 hours prior.</li>
          <li>➤ Rescheduling within 24 hours may be subject to availability and additional fees.</li>
        </ul>

        <h2 className="policy-heading">Late Arrival</h2>
        <ul className="policy-list">
          <li>➤ If a patient arrives late, the consultation time may be shortened to avoid delays for other patients.</li>
          <li>➤ If the delay exceeds 15–20 minutes, the appointment may be treated as a no-show.</li>
        </ul>

        <h2 className="policy-heading">Treatment & Package Services</h2>
        <ul className="policy-list">
          <li>➤ Fees for treatment packages, therapies, or customized care plans are non-refundable once initiated.</li>
          <li>➤ Unused sessions may be rescheduled within the validity period but are not eligible for a refund.</li>
        </ul>

        <h2 className="policy-heading">Emergency Cancellations</h2>
        <ul className="policy-list">
          <li>➤ In case of emergencies or unforeseen circumstances, exceptions may be considered at the sole discretion of the practitioner/clinic.</li>
        </ul>

        <h2 className="policy-heading">Mode of Consultation</h2>
        <ul className="policy-list">
          <li>➤ For online/video consultations, patients must ensure proper connectivity.</li>
          <li>➤ Technical issues from the patient's side will not qualify for refunds, but reasonable attempts will be made to reschedule.</li>
        </ul>

        <h2 className="policy-heading">Contact</h2>
        <p>
          ➤ For queries or concerns about data protection, please contact our Data
          Protection Officer at{" "}
          <a href="mailto:info@medayus.com" className="policy-link">
            info@medayus.com
          </a>
          .
        </p>
      </div>
    </>
  );
}